export const SIGNED_IN_MODE = 'SIGNED_IN_MODE'

export const SET_USER = 'SET_USER';

export const AUTH_STATE = 'AUTH_STATE';

export const NAME_FIELD = 'name';
export const EMAIL_FIELD = 'email';
export const PASSWORD_FIELD = 'password';
export const PASSWORD_CONFIRMATION_FIELD = 'password_confirmation';
export const USER_AGREEMENT_FIELD = 'agree';

export const TOKEN_FIELD = 'token';
export const ADMIN_FIELD = 'admin';
export const USERNAME_FIELD = 'username';
export const SET_AUTHORIZED = 'SET_AUTHORIZED';
